import { Button, Center } from '@chakra-ui/react'
import { useCMAStore } from 'features/CMA/infra/react/CMAState'
import { useEffect, useState } from 'react'
import { CompsInitializeModal } from '../CompsInitializeModal/CompsInitializeModal'

export const CompsInitializeStep = () => {
  const [isModalOpen, setIsModalOpen] = useState(true)
  const reportStatus = useCMAStore(state => state.local.report.status)

  // When the report status changes from 'initiated' to something else,
  // the modal was auto-confirmed and we should consider it closed
  useEffect(() => {
    if (reportStatus !== 'initiated')
      setIsModalOpen(false)
  }, [reportStatus])

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <CompsInitializeModal
        isOpen={isModalOpen}
        onCancel={handleCloseModal}
      />

      {!isModalOpen && (
        <Center height='100%' flex='1 1 0'>
          <Button
            colorScheme='positive'
            size='lg'
            variant='solid'
            onClick={handleOpenModal}
          >
            Run Comps
          </Button>
        </Center>
      )}
    </>
  )
}
